import { render } from "./InViewImage.vue?vue&type=template&id=52d1fc21&scoped=true&ts=true"
import script from "./InViewImage.vue?vue&type=script&lang=ts"
export * from "./InViewImage.vue?vue&type=script&lang=ts"

import "./InViewImage.scss?vue&type=style&index=0&id=52d1fc21&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d1fc21"]])

export default __exports__